import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_EMPLOYEE_TYPES } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const employeeTypes = {
  namespaced: true,
  state: buildInitialState({
    employeeTypeList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setEmployeeTypes: (state, employeeTypes) => {
      state.employeeTypeList = employeeTypes
    }
  },
  actions: {
    getEmployeeTypes: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_EMPLOYEE_TYPES })
        .then(json => json.data)
        .then(employeeTypes => {
          commit('updateStatus', { status: COMPLETE })
          commit('setEmployeeTypes', employeeTypes)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default employeeTypes
